import { api } from 'services/api'

export const getList = () => {
  return api.get<any[]>('/posts', { params: { per_page: 20}}).then(response => response.data)
}

export const getDetail = (id: string) => {
  return api.get<any[]>(`/posts/?slug=${id}`).then(response => response.data[0])
}